// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"5561d30e","638":"a8870180"}[chunkId] + ".chunk.js";
};